import { render } from "./Menu.vue?vue&type=template&id=72902dba&scoped=true&ts=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=72902dba&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72902dba"]])

export default __exports__